import { render, staticRenderFns } from "./validated-form.vue?vue&type=template&id=62fdc995&scoped=true"
import script from "./validated-form.vue?vue&type=script&lang=js"
export * from "./validated-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fdc995",
  null
  
)

export default component.exports